import { DeviceMeasurement } from '../models/deviceMeasurement'

export interface DeviceMeasurementsStateType {
  deviceMeasurements: DeviceMeasurement[]
  singleDeviceMeasurements: DeviceMeasurement | null
}

const DeviceMeasurementsState: () => DeviceMeasurementsStateType = () => ({
  deviceMeasurements: [],
  singleDeviceMeasurements: null,
})

export default DeviceMeasurementsState
